import {
  Box,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@material-ui/core';

const OrderHistoryListHeader = ({
  productThumbnailUrl,
  classname,
  label,
  pricingPlanUrl,
  showInvoice,
}) => (
  <ListItem className={classname.orderListHeader} disableGutters={true}>
    <Box width="50%">
      <ListItemAvatar className={`${showInvoice && classname.avatarListItem}`}>
        <img
          alt="logo"
          src={productThumbnailUrl}
          variant="square"
          className={classname.productLogo}
        />
      </ListItemAvatar>
      {pricingPlanUrl && (
        <ListItemAvatar>
          <img
            alt="Affiliate Partnership Logo"
            src={pricingPlanUrl}
            variant="square"
            className={classname.affiliateLogo}
          />
        </ListItemAvatar>
      )}
    </Box>
    {showInvoice && (
      <ListItemText width="50%" className={classname.taxInvoice || ''}>
        <Typography className={classname.titilliumSemiboldFont}>{label}</Typography>
      </ListItemText>
    )}
  </ListItem>
);

export default OrderHistoryListHeader;
